import Backbone = require("backbone");

class Model<T> extends Backbone.Model {
    
    changed: T;
    attributes: T;

    static about = `
Extends a backbone model by providing a data attribute.
    `;

    constructor(args: T, options = {}) {
        super(args, options);
    }

    get data() {
        return <T>this.attributes; // is this always up-to-date?
    }

}

export = Model;